<template>
  <div>
      <div style="text-align: center; margin-top: 20px; margin-bottom: 50px">
        <img src="https://raizzoncdn.b-cdn.net/home/home_webmaster_lines.png" width="100%" alt="">
      </div>
      
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section3.vue